module.exports = __webpack_public_path__ + "static/media/ryan.81a40ec2.jpg";